import { ChangeDetectionStrategy, ChangeDetectorRef, Component,computed, ElementRef, EventEmitter, Input, OnInit, Output, signal, TemplateRef, ViewChild, WritableSignal } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs';
import { SignatureTypes } from '../../../../helpers/helpers';
import { UserSelectedSignatureModel } from '../../../../model/firm/user-selected-signature.model';
import { SaveSignatureModel } from '../../../../model/template/client-eng-letter.model';
import { ApiService } from '../../../../services/api.service';
import { modules } from '../../../../services/app-config';
import { EncodingService } from '../../../../services/encoding.service';
import { FirmService } from '../../../../services/firm.service';
import { UnsavedChangesDialogComponent } from 'src/app/components/dialogs/unsavedChangesDialog/unsavedChangesDialog.component';
import { GenerateRandomUtils } from 'src/app/helpers/random-utils';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { SignaturePadComponent } from '../../../../components/remote-shared/signature-pad/signature-pad.component';
import { MatRadioModule } from '@angular/material/radio';
import { SignatureFilterPipe } from 'src/app/helpers/signature-filter.pipe';
import { DragDropDirective } from 'src/app/helpers/drag-and-drop-upload';

@Component({
  selector: 'app-signatures',
  templateUrl: './signatures.component.html',
  styleUrls: ['./signatures.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatListModule, MatSlideToggleModule, MatDialogModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule,
    SignaturePadComponent, MatRadioModule, SignatureFilterPipe, DragDropDirective
   ]
})

export class SignaturesComponent implements OnInit {
@Output() spinnerConfig = new EventEmitter<boolean>(null);
  imageFile: any;
  savedSignature: any;
  allSignaturesData: SaveSignatureModel[] = [];
  allSignaturesOriginalData: SaveSignatureModel[] = [];
  signatureEditData: any = [];
  isSignatureEdit: boolean = false;
  signatureName: string;
  firmSignatureID: any;
  loggedInUserData;
  firmuseracctid;
  bucketName: any;
  s3signatureKey: any;
  deleteSignatureData: any = {};
  drawnSign: any;
  addSignatureType: string = SignatureTypes.DRAW;
  signatureType: any;
  signatureTypeSelected: string = SignatureTypes.DRAW;
  signatureText: string;
  disableSave: Boolean = true;
  searchText= computed(() => {
    return this._searchTerm().toLowerCase().trim();
  })
  previewImage: any;
  signaturesAvailable: WritableSignal<boolean> = signal<boolean>(false);
  clickCustomEvent: any;
  private autoSelectInProgress = false;


  @ViewChild('deletesignatureDialog') deleteSignatureDialog: TemplateRef<any>;
  @ViewChild('addSignatureDialog') addSignatureDialog: TemplateRef<any>;
  @ViewChild("signatureNameEdit") signatureNameInput: ElementRef;
  useracctid: any;
  private _searchTerm = signal('');
  @Input() set searchTerm(value: string) {
    this._searchTerm.set(value);
  }
  
  constructor(private apiService: ApiService, private encodingService: EncodingService,
              private toastr: ToastrService, private cdr: ChangeDetectorRef,
              public dialog: MatDialog, private firmService: FirmService) { }

  ngOnInit() {
    this.loggedInUserData = JSON.parse((localStorage.getItem('userDetails')));
    this.bucketName = this.loggedInUserData.s3BucketName;

    if (this.loggedInUserData && this.loggedInUserData.useracctid) {
      this.useracctid = this.loggedInUserData.useracctid
    }
    if (this.loggedInUserData && this.loggedInUserData.firmUserAcctId) {
      this.firmuseracctid = this.loggedInUserData.firmUserAcctId
    }
    this.s3signatureKey = 'Engagements/' + this.firmuseracctid + '_Firm/Templates/Common/Signatures';
    this.cdr.markForCheck();

    this.signatureType = SignatureTypes
    this.getSignatures();
    this.cdr.markForCheck();
  }

  getCanvasSignature(data) {
    this.drawnSign = data;
    this.checkValidForm();
  }

  getSignatures() {
    this.isSignatureEdit = false;
    this.signatureEditData = [];
    this.spinnerConfig.emit(true);
    this.firmService.getFirmSignature(this.firmuseracctid).pipe(finalize(() => this.spinnerConfig.emit(false))).subscribe({
      next: res => {
        if(res){
          let result = JSON.parse(res);
          if (result) {
            this.allSignaturesData = result;
            this.allSignaturesOriginalData = JSON.parse(JSON.stringify(result));
            if (this.allSignaturesData?.length > 0) {
              this.signaturesAvailable.set(true);
              const allDefaultSelected = this.allSignaturesData.filter((e) => e.isuserselected === 1);
              // Only auto-select if there are no selected signatures and more than one signature exists
              if (allDefaultSelected.length === 0 && !this.autoSelectInProgress) {
                this.autoSelectFirstSignature();
              }
            } else {
              this.signaturesAvailable.set(false)
            }
          }
          this.allSignaturesData.forEach((element, key) => {
            this.apiService.getFiles(element.jsonfilepath).subscribe(res => {
              this.allSignaturesData[key].s3JSONFilePath = res;
              this.cdr.markForCheck();
            });
          });
          this.cdr.markForCheck();
        }
      }, error: e => {
        this.toastr.error(e.error);
      }
    });
    this.cdr.markForCheck();
  }

  setFocus() {
    setTimeout(() => {
      this.signatureNameInput.nativeElement.focus();
    }, 1);
  }

  checkValidForm() {
    this.cdr.markForCheck();
    if (this.addSignatureType == SignatureTypes.UPLOAD && (this.imageFile === null || this.imageFile === undefined)) {
      this.disableSave = true
      return
    }
    if (this.addSignatureType == SignatureTypes.TEXT && (this.signatureText === null || this.signatureText ===  undefined)) {
      this.disableSave = true
      return
    }
    if (this.addSignatureType == SignatureTypes.DRAW && (this.drawnSign === null || this.drawnSign === undefined)) {
      this.disableSave = true
      return
    }
    if (this.signatureName?.trim() == '' || this.signatureName === null || this.signatureName === undefined) {
      this.disableSave = true
      return
    }
    this.disableSave = false;
    this.cdr.markForCheck();
  }
  saveSignature(name) {
    let JsonFilePath;
    let jsonFileName;
    if (this.addSignatureType === SignatureTypes.UPLOAD) {
      const lastDotIndex = name?.lastIndexOf('.');
      const baseName = name?.substring(0, lastDotIndex);
      const extension = name?.substring(lastDotIndex);
      const randomString = GenerateRandomUtils.generateRandomString(3, 2);
      jsonFileName = `${baseName}${randomString}${extension}`;
    } else {
      jsonFileName = name;
    }
    JsonFilePath = jsonFileName ? `${this.s3signatureKey}/${jsonFileName}` : this.s3signatureKey;
    let obj = {
      "firmsignature": {
        "signature": this.signatureName,
        "jsonfilename": this.addSignatureType !== this.signatureType.TEXT ? jsonFileName : null,
        "jsonfilepath": this.addSignatureType !== this.signatureType.TEXT ? JsonFilePath : null,
        "isdelete": 0,
        "signature_type": this.addSignatureType,
        "signature_text": this.addSignatureType === this.signatureType.TEXT ? this.signatureText : null,
        "firmsignatureid": 0
      }
    };
    this.spinnerConfig.emit(true);
    this.firmService.saveFirmSignature(JSON.stringify(obj)).pipe(finalize(() => this.spinnerConfig.emit(false))).subscribe({
      next: res => {
        if(res.status === 200) {
          this.firmSignatureID = res.data;
          if (this.addSignatureType === this.signatureType.UPLOAD) {
            this.saveJson(jsonFileName)
          } else {
            this.toastr.success('Signature added successfully');
            this.getSignatures();
          }
          this.signatureName = null;
          this.signatureText = null;
          this.drawnSign = null;
          this.cdr.markForCheck();
        }
      }, error: e => {
        this.toastr.error(e.error);
      }
    })
  }

  saveDrawnSignature() {
    const obj = {
      "firmId": this.firmuseracctid,
      "status": 0,
      "appSyncId": this.useracctid,
      "isClient": false,
      "signatureString": this.drawnSign,
    }
    this.spinnerConfig.emit(true);
    this.apiService.saveBase64Image(obj).pipe(finalize(() => this.spinnerConfig.emit(false))).subscribe((res) => {
      this.imageFile = res;
      this.saveSignature(res.fileName);
    }, error => {
      this.toastr.error(error.error);
    });
  }

  saveSignatureName(data) {
    let obj = {
      "firmsignature": {
        "signature": data.signature,
        "signature_type": data?.signature_type,
        "jsonfilename": data?.signature_type !== this.signatureType.DRAW ? data.jsonfilename : null,
        "jsonfilepath": data?.signature_type !== this.signatureType.DRAW ? data.jsonfilepath : null,
        "isdelete": 0,
        "signature_text": data?.signature_type === this.signatureType.TEXT ? data.signature_text : null,
        "firmsignatureid": data.firmsignatureid,
        "is_default": data.isuserselected,
      }
    };

    let finalObj = JSON.stringify(obj);
    this.spinnerConfig.emit(true);
    this.firmService.saveFirmSignature(finalObj).pipe(finalize(() => this.spinnerConfig.emit(false))).subscribe({
      next: res => {
        if(res.status === 200) {
          this.getSignatures();
          this.toastr.success('Signature renamed successfully');
        }
      }, error: e => {
        this.toastr.error(e.error);
      }
    })
  }

  private autoSelectFirstSignature() {
      this.autoSelectInProgress = true;
      this.saveSignatureSelection(this.allSignaturesData[0]);
  }

  saveSignatureSelection(value) {
    const userSelectedSignature: UserSelectedSignatureModel = {
      signatureId: value.firmsignatureid,
      isUserSelected: value.isuserselected === 0 ? 1 : 0
    }

    this.spinnerConfig.emit(true);
    this.firmService.saveUserSelectedSignature(userSelectedSignature).pipe(finalize(() => {
      this.spinnerConfig.emit(false);
      this.autoSelectInProgress = false;
    })).subscribe({
      next: res => {
        if (res.status === 200 && res.data) {
          this.toastr.success('Signature selected successfully');
          // Only call getSignatures() if this was not an auto-selection
          if (!this.autoSelectInProgress) {
            this.getSignatures();
          } else {
            // Just update the local data
            const signature = this.allSignaturesData.find(s => s.firmsignatureid === value.firmsignatureid);
            if (signature) {
              signature.isuserselected = 1;
            }
          }
          this.cdr.markForCheck();
        }
      }, error: e => {
        this.toastr.error(e.error);
      }
    });
  }

  deleteSignatureConfirmation(data) {
    this.deleteSignatureData = data;
    const dialogRef = this.dialog.open(this.deleteSignatureDialog, { disableClose: true });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteSignature(data);
      } else {
        this.deleteSignatureData = {};
      }
    });
  }
  addSignature() {
    const dialogRef = this.dialog.open(this.addSignatureDialog, { disableClose: true });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {        
        if (this.addSignatureType == SignatureTypes.DRAW) {
          this.saveDrawnSignature();
        } else if (this.addSignatureType == SignatureTypes.UPLOAD) {
          this.saveSignature(this.imageFile?.name);
        } else if (this.addSignatureType == SignatureTypes.TEXT) {
          this.saveSignature(null);
        }
      } else {
        this.drawnSign = null;
        this.signatureName = '';
        this.addSignatureType = SignatureTypes.DRAW;
        this.signatureText = '';
        this.previewImage = '';
      }
      this.disableSave = true;
    });
  }
  clearForm() {
    this.addSignatureType = this.signatureType.DRAW;
    this.signatureText = '';
    this.drawnSign = null;
    this.imageFile = null;
  }

  deleteSignature(data) {
    const obj = {
      "firmsignature": {
        "signature": data.signature,
        "signature_type": data?.signature_type || 'upload',
        "jsonfilename": data?.signature_type !== this.signatureType.DRAW ? data.jsonfilename : null,
        "jsonfilepath": data?.signature_type !== this.signatureType.DRAW ? data.jsonfilepath : null,
        "isdelete": 1,
        "signature_text": data?.signature_type === this.signatureType.TEXT ? data.signature_text : null,
        "firmsignatureid": data.firmsignatureid,
        "is_default": data.isuserselected,
      }
    };
    const finalObj = JSON.stringify(obj);
    this.spinnerConfig.emit(true);
    this.firmService.saveFirmSignature(finalObj).pipe(finalize(() => this.spinnerConfig.emit(false))).subscribe({
      next: res => {
        if(res.status === 200) {
          const deletedIndex = this.allSignaturesData.indexOf(data)
          this.getSignatures();
          this.toastr.success('Signature deleted successfully');
          this.cdr.markForCheck();
        }
      }, error: e => {
        this.toastr.error(e.error);
      }
    })
  }

  saveJson(jsonFileName) {
    let formData: FormData = new FormData();
    formData.append('file', this.imageFile, jsonFileName);
    const uploadObj = JSON.stringify({
      "module": modules[15],
      "firmId": this.firmuseracctid,
      "status": 0,
      "folderName": "Signatures",
      "appSyncId": this.loggedInUserData.useracctid,
      "extension": "temp"
    })
    formData.append('upload', this.encodingService.enData(uploadObj, "body"));

    this.spinnerConfig.emit(true);
    this.apiService.saveAndGetFileNamePath(formData).pipe(finalize(() => this.spinnerConfig.emit(false))).subscribe(response => {
      this.toastr.success('Signature added successfully');
      this.getSignatures();
      this.previewImage = '';
      this.imageFile = '';
      this.imageFile = '';
    }, error => {
      this.toastr.error(error.error);
    })
    this.cdr.markForCheck();
  }

  validateUnsavedChanges(data, type) {
      if (type === 'edit') {
        this.editSignature(data);
        this.setFocus();
      } else if (type === 'delete') {
        this.deleteSignatureConfirmation(data);
      } else if (type === 'selection') {
        this.saveSignatureSelection(data);
      }
  }

  editSignature(data) {
    data.isSignatureEdit = true;
    this.signatureEditData = data;
    this.isSignatureEdit = true;
  }

  closeSignature(data) {
    data.isSignatureEdit = false;
    this.isSignatureEdit = false;
    this.signatureEditData = [];
  }

  saveUnsavedChanges() {
    this.saveSignatureName(this.signatureEditData);
  }

  cancelUnsavedChanges() {
    let isExcludedButton = false;
    if (this.clickCustomEvent && this.clickCustomEvent.relatedTarget) {
      const relatedElement = this.clickCustomEvent.relatedTarget;
      isExcludedButton =
        relatedElement instanceof HTMLElement &&
        relatedElement.tagName === 'BUTTON' &&
        relatedElement.classList.contains('my-custom-setting');
      if (relatedElement instanceof HTMLElement) {
        relatedElement.click();
      }
    }
    if (!isExcludedButton) {
    this.getSignatures();
    }
  }

 changeTab(event){
  if(event.target.value !== undefined){
    this.signatureText = null;
    this.drawnSign = null;
    this.imageFile = null;
    this.previewImage = null;
    this.disableSave = true;
  }
 }

  uploadSignature(event, type) {
    let file: any = [];
    if (type === 'dnd') {
      file = event;
    } else {
      file = event.target.files;
    }

    if (this.isValidFileCheck(file[0])) {
      if (file && file.length > 0) {
        this.imageFile = file[0];

        const fileReader: FileReader = new FileReader();
        fileReader.readAsDataURL(file[0]);

        fileReader.onload = (event: Event) => {
          var image = new Image();
          image.src = fileReader.result as string;

          image.onload = () => {
            let height = image.height;
            let width = image.width;
            if (height > 125 || width > 200) {
              this.toastr.error('Image size should not exceed the maximum limits');
            } else {
              this.previewImage = fileReader.result;
            }
            this.checkValidForm();
          };
        }
      }
    } else {
      this.toastr.error('Please upload valid image file');
    }
  }

  isValidFileCheck(file: any) {
    let fileName = file.name.toLowerCase();
    if (fileName.endsWith(".jpeg") || fileName.endsWith(".jpg") || fileName.endsWith(".png") || fileName.endsWith(".gif")) {
      return true;
    } else {
      return false;
    }
  }

  removeImage() {
    this.imageFile = null;
    this.previewImage = null;
    this.disableSave = true;
  }

  onSignatureEditBlur(event: any, buttonSection: HTMLElement, data: any) {
    this.clickCustomEvent = event;
    const isChanged = this.allSignaturesOriginalData.some(sign => {
      return sign.firmsignatureid === data.firmsignatureid && sign.signature !== data.signature;
    });
    const isSaveButton = event?.relatedTarget?.parentElement === buttonSection;
    if (!isSaveButton && isChanged) {
      setTimeout(() => {
        const dialogRef = this.dialog.open(UnsavedChangesDialogComponent, {
          restoreFocus: false
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.cancelUnsavedChanges();
          } else {
            this.saveUnsavedChanges()
          }
        });
      }, 100);
    }
  }

}
